import { Paperclip, X } from "lucide-react";
import { useState } from "react";
import { uploadImage } from "../../sdk/upload/upload";
import Loading from "../../shared/Loading";

const DeclineDisburse = ({
  closeDeclineDisburse,
  handleDeclineDisburseSuccess,
  declineDisburseDetails,
  setDeclineDisburseDetails,
  loading,
}) => {
  const [fileLoading, setFileLoading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");

  const handleReasonChange = (e) => {
    setDeclineDisburseDetails((prev) => ({
      ...prev,
      reason: e.target.value,
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileLoading(true);
    try {
      const res = await uploadImage(file);
      setDeclineDisburseDetails((prev) => ({
        ...prev,
        supportingDocumentUrl: res.url,
      }));
      setUploadedFileName(file.name);
    } catch (error) {
      console.error("File upload failed:", error);
    } finally {
      setFileLoading(false);
    }
  };

  return (
    <div
      onClick={closeDeclineDisburse}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[550px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeDeclineDisburse}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>

        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Decline Loan Disbursement
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Please provide a clear reason for declining the loan disbursement.
            You may also upload any supporting documents or photos to justify
            this action. This information will be recorded for transparency and
            audit purposes.
          </p>

          {/* Reason Textarea */}
          <div className="my-[10px] w-full">
            <textarea
              value={declineDisburseDetails.reason}
              onChange={handleReasonChange}
              className="h-[150px] w-full text-[14px] rounded-[5px] px-[10px] py-[8px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
              placeholder="Add additional information here"
            />
          </div>

          {/* File Upload */}
          <label htmlFor="file-upload" className="cursor-pointer">
            <div className="h-[45px] rounded-[5px] w-full px-[15px] gap-[10px] border border-[#000000] flex items-center">
              <Paperclip size={16} color="#000000" />
              <p className="text-[#000000] text-[16px] font-normal">
                Attach a file (.pdf, .docx, .doc, .jpeg, .png)
              </p>
            </div>
          </label>
          <input
            id="file-upload"
            type="file"
            className="hidden"
            accept=".pdf,.doc,.docx,.jpeg,.jpg,.png"
            onChange={handleFileChange}
          />

          {/* Show uploaded file info or loading */}
          {fileLoading ? (
            <div className="mt-2">
              <Loading />
            </div>
          ) : (
            declineDisburseDetails.supportingDocumentUrl && (
              <p className="mt-2 text-sm text-[#5C5C5C]">
                Uploaded:{" "}
                <span className="font-medium">{uploadedFileName}</span>
              </p>
            )
          )}
        </div>

        {/* Footer Buttons */}
        <div className="absolute bottom-[20px] left-[20px] right-[20px] flex items-center justify-between">
          <button
            onClick={closeDeclineDisburse}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#222222] font-medium"
          >
            Back
          </button>
          <div className="flex items-center justify-center gap-[10px]">
            <button
              onClick={closeDeclineDisburse}
              className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
            >
              Cancel
            </button>
            <button
              disabled={loading}
              onClick={handleDeclineDisburseSuccess}
              className="h-[35px] flex items-center justify-center gap-[10px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
            >
              {loading && <Loading />}
              Decline Disbursement
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeclineDisburse;
